module.exports = __webpack_public_path__ + "static/img/19.e470a07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/19.png
// module id = PGUc
// module chunks = 0